import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

//import Contexts provider
import AppContextProvider from "./contexts/AppContextProvider";

import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter basename={process.env.REACT_APP_PUBLIC_URL}>
    <AppContextProvider>
      <App />
    </AppContextProvider>
  </BrowserRouter>
);
